import { render, staticRenderFns } from "./CatalogoEquipos.vue?vue&type=template&id=fc50d424&"
import script from "./CatalogoEquipos.vue?vue&type=script&lang=js&"
export * from "./CatalogoEquipos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports